'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Button2 = require('./Button');

var _Button3 = _interopRequireDefault(_Button2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Down = (_temp = _class = function (_Button) {
  (0, _inherits3.default)(Down, _Button);

  function Down() {
    (0, _classCallCheck3.default)(this, Down);
    return (0, _possibleConstructorReturn3.default)(this, _Button.apply(this, arguments));
  }

  Down.prototype.process = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', this.getParent().down());

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process() {
      return _ref.apply(this, arguments);
    }

    return process;
  }();

  return Down;
}(_Button3.default), _class.defaultProps = {
  text: 'Remove'
}, _temp);
exports.default = Down;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Down.js
 ** module id = 1272
 ** module chunks = 0
 **/